<template>
    <header class="header">
        <button
            v-if="gerenciarLocal"
            class="btn btn-primary btn-extra-round locals-group"
            @click="showLocalsGroupCreationModal = true"
        >
            {{ this.$t("message.spots.message.registerSpotsGroup") }}
        </button>

        <button
            v-if="gerenciarLocal"
            class="btn btn-primary btn-extra-round locals-group"
            @click="showLocalsCreationModal = true"
        >
            {{ this.$t("message.spots.message.registerSpot") }}
        </button>

        <button
            v-if="gerenciarLocal"
            class="btn btn-primary btn-extra-round"
            @click="showLocalsSSID = true"
        >
            SSID's
        </button>

        <locals-ssid-modal v-if="showLocalsSSID" v-model="showLocalsSSID" />

        <file-upload-arquive v-if="isAdmin" @created="reloadLocaleTable" />

        <access-point-controller-list v-if="isMaster" />

        <div class="search-wrapper">
            <app-search @submit="search" />
        </div>

        <device-modal />
        <login-type-captive-modal />

        <app-released-ips-modal></app-released-ips-modal>

        <locals-creation-modal
            v-model="showLocalsCreationModal"
            @created="reloadLocaleTable"
        />

        <locals-group-creation-modal
            v-model="showLocalsGroupCreationModal"
            @created="reloadLocaleTable"
        />
    </header>
</template>
<script>
import AppReleasedIpsModal from "@views/admin/devices/components/device-modal/components/released-ips/ReleasedIpsModal";
import LoginTypeCaptiveModal from "@views/admin/devices/components/device-modal/components/login-type-captive-modal/LoginTypeCaptiveModal";
import DeviceModal from "@views/admin/devices/components/device-modal/DeviceModal";
import AppSearch from "@components/Search";
import LocalsCreationModal from "@views/locals/components/LocalsCreationModal";
import LocalsGroupCreationModal from "@views/locals/components/LocalsGroupCreationModal";
import LocalsSsidModal from "@views/locals/components/LocalsSSIDModal";
import FileUploadArquive from "@views/locals/components/LocalUploadArquive";
import AccessPointControllerList from "@components/modules/access-point/controller/list/AccessPointControllerList";
import EventBus from "@packages/event-bus";

export default {
    components: {
        LocalsCreationModal,
        LocalsGroupCreationModal,
        LocalsSsidModal,
        FileUploadArquive,
        AppSearch,
        DeviceModal,
        LoginTypeCaptiveModal,
        AppReleasedIpsModal,
        AccessPointControllerList,
    },

    data() {
        return {
            showLocalsCreationModal: false,
            showLocalsGroupCreationModal: false,
            showLocalsSSID: false,
        };
    },

    methods: {
        reloadLocaleTable() {
            this.showLocalsCreationModal = false;
            this.showLocalsGroupCreationModal = false;
            EventBus.$emit("RELOAD_LOCALE_TABLE");
        },
        search(val) {
            EventBus.$emit("SEARCH_LOCALE_TABLE", val);
        },
        async loadTimezones() {
            let timezonesList = await this.$api.general.loadTimezones();

            const timezoneOptions = Object.keys(timezonesList).map((key) => {
                return {
                    id: key,
                    label: timezonesList[key],
                };
            });

            this.$store.commit("LOCALS_SET_TIMEZONES", timezoneOptions);
        },
        async loadCategories() {
            const response = await this.$api.locals.getCategories();

            const categories = response.map((item) => {
                return {
                    id: item,
                    label: item,
                };
            });

            this.$store.commit("LOCALS_SET_CATEGORIES", categories);
        },
    },

    computed: {
        permissions() {
            return this.$store.state.users.user.permissions;
        },
        gerenciarLocal() {
            return this.permissions.find((x) => x === "MANAGE_LOCALS")
                ? true
                : false;
        },
        customizeLoginType() {
            return this.permissions.find((x) => x === "USE_CUSTOM_CAPTIVE_FORM")
                ? true
                : false;
        },
        isAdmin() {
            return this.$store.state.users.admin;
        },
        isMaster() {
            return this.permissions.includes("MASTER");
        },
    },

    async created() {
        await Promise.all([this.loadTimezones(), this.loadCategories()]);
    },
};
</script>
<style scoped lang="scss">
.header {
    display: flex;
    align-items: center;

    .locals-group {
        margin-right: 15px;
    }

    .search-wrapper {
        margin-left: auto;
    }
}
</style>
